import ReactOnRails from 'react-on-rails';

import Favorite from '../components/Favorite';
import Toast from '../components/Toast';
import DesignerCardImage from '../components/DesignerCardImage';
import InternalPromoteCard from '../components/InternalPromoteCard'
import FashionIcon from '../components/FashionIcon';
import Footer from '../components/Footer';
import FooterThemeImage from '../components/FooterThemeImage';
import Header from '../components/Header';
import ResultCardImage from '../components/ResultCardImage';
import TopPickCarouselImage from '../components/TopPickCarouselImage';
import { TopBreadcrumb, BottomBreadcrumb } from '../components/Breadcrumb';
import FacetFilter from '../components/FacetFilterWrapper';
import LazyloadImage from '../components/LazyloadImage';
import LatestCollectionCarousel from '../components/LatestCollectionCarousel';
import GalleryHeroImage from '../components/GalleryHeroImage';
import GalleryLocalFinder from '../components/GalleryLocalFinder';
import GalleryInstagramSection from '../components/GalleryInstagramSection';
import EngagementRingProgressBar from '../components/EngagementRingProgressBar';
import PaginationContainer from '../components/PaginationContainer';
import HeroSection from '../components/HeroSection';
import ResultsComponent from '../components/ResultsComponent';
import FeaturedDesignersComponent from '../components/FeaturedDesignersComponent'
import QuizBanner from '../components/QuizBanner';
import TKRetakeBanner from '../components/RetakeBanner';
import ReadMoreComponent from '../components/ReadMoreComponent';

ReactOnRails.register({
  TKRetakeBanner,
  Header,
  TopBreadcrumb,
  FacetFilter,
  GalleryHeroImage,
  LatestCollectionCarousel,
  LazyloadImage,
  GalleryInstagramSection,
  GalleryLocalFinder,
  DesignerCardImage,
  InternalPromoteCard,
  ResultCardImage,
  ResultsComponent,
  Favorite,
  FashionIcon,
  TopPickCarouselImage,
  FooterThemeImage,
  BottomBreadcrumb,
  Toast,
  EngagementRingProgressBar,
  Footer,
  PaginationContainer,
  HeroSection,
  ResultsComponent,
  FeaturedDesignersComponent,
  QuizBanner,
  ReadMoreComponent
});
